export default "__VITE_ASSET__0ecf7920__"